import { Box, Typography } from '@mui/material';
import React, { useContext } from 'react';
import CommentsTree from '../CommentsTree/CommentsTree';
import { useQuery } from 'react-query';
import { GlobalContext } from '../../contexts/globalContext';
import api from '../../api/api';
import PostCommentsSkeleton from './components/PostCommentsSkeleton/PostCommentsSkeleton';
import { EmptyState } from '../../images';
import { i18n } from '../../i18n/i18n';

interface ChipListProps {
    post: any;
}

const PostComments: React.FC<ChipListProps> = ({ post }) => {
    const { reportData, workspacesData, casesData } = useContext(GlobalContext);
    const {
        data: postComments,
        isLoading,
        isError,
    } = useQuery(
        [
            'postComments',
            workspacesData.activeWorkspace?.id,
            casesData.activeCaseId,
            reportData.streamId,
            post.contentId,
            post.platform,
        ],
        ({ queryKey }) =>
            api.report.fetchPostComments(
                queryKey[1] as number,
                queryKey[2] as string,
                queryKey[3] as string,
                queryKey[4],
                queryKey[5],
            ),
        {
            enabled: !!workspacesData.activeWorkspace?.id && !!casesData.activeCaseId && !!reportData.streamId,
            retry: false,
        },
    );
    let markedUser;
    const headlineArr = post.headline?.split(' replied on this');
    if (headlineArr?.length === 2 && headlineArr?.[1] === '') {
        markedUser = headlineArr[0];
    }
    return isError ? (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
            <EmptyState />
            <Typography variant="s24w700" className="color-bd" sx={{ mt: 3 }}>
                {i18n.translate("Can't Display Comments")}
            </Typography>
            <Typography className="color-md">{i18n.translate('Try again in a few minutes.')}</Typography>
        </Box>
    ) : isLoading ? (
        <PostCommentsSkeleton />
    ) : (
        postComments?.map((comment, index) => (
            <CommentsTree key={index} commentHead={comment} platform={post.platform} markedUser={markedUser} />
        ))
    );
};

export default PostComments;
